import type { RootLoaderData } from '@jane/bloom/types/loaders/rootLoader';
import { BloomError } from '@jane/bloom/utils/errors/bloomError';

import { useTypedRouteLoaderData } from './useTypedRouteLoaderData';

/**
 * Shorthand to retrieve loader data from the root route, which should be a match for every route.
 * @see @jane/bloom/root
 */
export const useRootLoaderData = (): RootLoaderData => {
  const data = useTypedRouteLoaderData('root');
  if (!data) {
    throw new BloomError({ message: 'No root loader data found' });
  }

  return data;
};
